import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ConnectDevicePage } from "../../../../../pages";

const connectDeviceQueryParamsSchema = z.object({
  "user-code": z.coerce.string().optional(),
});

export const Route = createFileRoute(
  "/_authenticated/_layout/_main/_centered/connect-device",
)({
  component: ConnectDevicePage,
  validateSearch: connectDeviceQueryParamsSchema,
});
